module.exports = __webpack_public_path__ + "static/media/nguyenkhoi.914473fc.gif";